import { GQLProductFragment } from '@theprintbar/graphql';
import { cn, getSortedSizes, isDefined } from '@theprintbar/shared';
import { Fragment } from 'react';
import { InfoPopup } from '../..';

interface SizeGuideProps {
	product: GQLProductFragment;
}
export function SizeGuideButton({ product }: SizeGuideProps) {
	const sizeGuide = product.sizeGuide.structure;
	const baseGuide = sizeGuide?.[0];
	const option1Label = baseGuide?.optionOne?.label;
	const option2Label = baseGuide?.optionTwo?.label;
	const option3Label = baseGuide?.optionThree?.label;

	const validLabels = [option1Label, option2Label, option3Label].filter(label => !!label);
	const colOptions = ['grid-cols-2', 'grid-cols-3', 'grid-cols-4'];
	const colClass = colOptions[validLabels.length - 1] || 'grid-cols-3';

	const sortedSizeGuide = getSortedSizes(product)
		.map(s => {
			return sizeGuide?.find(g => g?.size === s.variant.size.code);
		})
		.filter(isDefined);

	return !!baseGuide?.optionOne?.value ? (
		<>
			<InfoPopup buttonText="Size Guide" title="Size Guide" className="flex flex-row-reverse gap-1 font-normal no-underline">
				<div className={cn('grid w-full lg:min-w-96', colClass)}>
					{/* Headers */}
					<div className="border" />
					{validLabels.map((label, index) => (
						<div key={index} className="text-center px-4 py-1 font-bold border">
							{label}
						</div>
					))}

					{/* Sizes */}
					{sortedSizeGuide?.map((row, rowIndex) =>
						!row ? null : (
							<Fragment key={rowIndex}>
								<div className="font-bold border px-4 py-1 text-center">{row.size}</div>
								{!!option1Label && <div className="text-center px-4 py-1 border">{row.optionOne?.value}</div>}
								{!!option2Label && <div className="text-center px-4 py-1 border">{row.optionTwo?.value}</div>}
								{!!option3Label && <div className="text-center px-4 py-1 border">{row.optionThree?.value}</div>}
							</Fragment>
						),
					)}
				</div>
			</InfoPopup>
		</>
	) : null;
}
